export default {
  data() {
    return {
      autoUpdate: true, // auto-update
      updateExists: false, // new contents available
      registration: null, // object
      refreshing: false, // Prevent multiple refreshes
      _pendingReload: false, // Deferred reload flag
    };
  },
  created() {
    // Listen for our custom event from the SW registration
    document.addEventListener("swUpdated", this.updateAvailable, { once: true });

    if (navigator.serviceWorker) {
      // Prevent multiple refreshes
      navigator.serviceWorker.addEventListener("controllerchange", () => {
        if (this.refreshing) return;
        this.refreshing = true;

        // If page is hidden (suspended/backgrounded), defer reload until visible
        if (document.visibilityState === "hidden") {
          console.log("[swUpdates] Deferring reload - page is hidden/suspended");
          this._pendingReload = true;
          return;
        }
        // Here the actual reload of the page occurs
        window.location.reload();
      });
    }

    // If a reload was deferred while suspended, execute it when page becomes visible
    document.addEventListener("visibilitychange", () => {
      if (this._pendingReload && document.visibilityState === "visible") {
        console.log("[swUpdates] Executing deferred reload after resume");
        this._pendingReload = false;
        window.location.reload();
      }
    });
  },
  methods: {
    updateAvailable(event) {
      // console.log(event);
      this.registration = event.detail;
      if (this.autoUpdate) {
        this.refreshApp();
      } else {
        this.updateExists = true;
      }
    },
    refreshApp() {
      this.updateExists = false;
      // Make sure we only send a 'skip waiting' message if the SW is waiting
      if (!this.registration || !this.registration.waiting) return;
      console.log("updating ...");
      // Send message to SW to skip the waiting and activate the new SW
      this.registration.waiting.postMessage({ type: "SKIP_WAITING" });
    },
  },
};
